import { render } from "./TraitRanksApesClueCard.vue?vue&type=template&id=f016b8b6"
import script from "./TraitRanksApesClueCard.vue?vue&type=script&lang=js"
export * from "./TraitRanksApesClueCard.vue?vue&type=script&lang=js"

import "./TraitRanksApesClueCard.vue?vue&type=style&index=0&id=f016b8b6&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__